import { isDate } from 'date-fns/isDate';
import { isEqual } from 'date-fns/isEqual';
import get from 'lodash/get';

import { AbstractSpecification } from './specification';

export class DateEqualSpecification<T> extends AbstractSpecification<T> {
   constructor(private compareDate: Date | string, private propertyPath: string) {
      super();
   }

   isSatisfiedBy = (candidate: T | undefined): boolean => {
      if (candidate === undefined) return false;
      const objectProperty = get(candidate, this.propertyPath);
      if (!objectProperty || !isDate(objectProperty)) return false;
      return isEqual(this.compareDate, objectProperty);
   };
}
